import {DefaultTheme} from '@react-navigation/native';

const baseTheme = {
  dark: false,

  /* Font: */
  fontFamily: 'OpenSans-Regular', // 400
  fontFamilyItalic: 'OpenSans-Italic', // 400 Italic
  fontFamilyBold: 'OpenSans-Bold', // 700

  fontFamilySerif: 'NotoSerif-Regular', // 400
  fontFamilySerifItalic: 'NotoSerif-Italic', // 400 Italic
  fontFamilySerifBold: 'NotoSerif-Bold', // 700

  /* Colors: */
  colors: {},

  /* Navigation */
  navHeight: 54,
  /** Bottom tab bar on web needs extra vertical space so labels are not clipped. */
  tabBarHeight: 64,

  /* Margins */
  hMargin: 15,
  vMargin: 15,

  /* Layout */
  containerWidth: 1200,
  fonts: DefaultTheme.fonts,
};

export default baseTheme;

export const lightTheme = {
  ...baseTheme,
  name: 'lightTheme',
  colors: {
    ...baseTheme.colors,
    primary: '#c12034',
    background: '#fcfcfc',
    navBackground: '#fff',
    transparentBackground: 'rgba(250, 250, 250, 0.98)',
    text: '#222',
    textInverted: '#fff',
    textLight: '#9a9a9a',
    textSidebar: '#222',
    border: '#eaeaea',
    borderDark: '#d0d0d0',
    icon: '#a6a6a6',
    tabIcon: '#999',
    shadow: '#c8c8c8',
    card: '#fff',
    notification: '#c12034',
  },
  statusBar: {
    backgroundColor: '#fff',
    textColor: '#222',
  },
  images: {
    cfcImageSource: require('../../assets/images/cfc_logo.png'),
    bibleImageSource: require('../../assets/images/biblijska_liga_logo.png'),
    echeckinImageSource: require('../../assets/images/echeckin_logo.png'),
    biblijaLogoImageSource: require('../../assets/images/biblija_logo.png'),
  },
};

const darkTheme = {
  ...baseTheme,
  name: 'darkTheme',
  colors: {
    ...baseTheme.colors,
    primary: '#ec9aa4',
    //primary: '#fff',
    background: '#343434',
    navBackground: '#292929',
    transparentBackground: 'rgba(41, 41, 41, 0.98)',
    text: '#fff',
    textInverted: '#292929',
    textLight: '#9a9a9a',
    textSidebar: '#9a9a9a',
    border: '#4c4c4c',
    borderDark: '#6e6e6e',
    icon: '#a6a6a6',
    tabIcon: '#a6a6a6',
    shadow: '#000',
    card: '#292929',
    notification: '#ec9aa4',
  },
  statusBar: {
    backgroundColor: '#292929',
    textColor: '#ffffff',
  },
  images: {
    cfcImageSource: require('../../assets/images/cfc_logo_light.png'),
    bibleImageSource: require('../../assets/images/biblijska_liga_logo_light.png'),
    echeckinImageSource: require('../../assets/images/echeckin_logo_light.png'),
    biblijaLogoImageSource: require('../../assets/images/biblija_logo_grayscale.png'),
  },
};

const sepiaTheme = {
  ...baseTheme,
  name: 'sepiaTheme',
  colors: {
    ...baseTheme.colors,
    primary: '#353535',
    background: '#f3e6d8',
    navBackground: '#eadbcb',
    transparentBackground: 'rgba(234, 219, 203, 0.98)',
    text: '#403126',
    textInverted: '#eadbcb',
    textLight: '#9f8a7d',
    textSidebar: '#7b5742',
    border: '#e2cfba',
    borderDark: '#ad9982',
    icon: '#8c7a66',
    tabIcon: '#8d7a7a',
    shadow: '#aa9683',
    card: '#eadbcb',
    notification: '#353535',
  },
  statusBar: {
    backgroundColor: '#eadbcb',
    textColor: '#222',
  },
  images: {
    cfcImageSource: require('../../assets/images/cfc_logo.png'),
    bibleImageSource: require('../../assets/images/biblijska_liga_logo.png'),
    echeckinImageSource: require('../../assets/images/echeckin_logo.png'),
    biblijaLogoImageSource: require('../../assets/images/biblija_logo_sepia.png'),
  },
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
  sepia: sepiaTheme,
};

export const getThemeByValue = val => {
  for (const theme of Object.keys(themes)) {
    if (themes[theme]['name'] === val) return themes[theme];
  }
  return null;
};

export const readingTheme = {
  lightTheme: 'theme-light',
  darkTheme: 'theme-dark',
  sepiaTheme: 'theme-sepia',
};

export const readingFontStyles = {
  sans: 'font-sans',
  serif: 'font-serif',
};

export const readingFontSizes = {
  small: 'font-small',
  normal: 'font-normal',
  large: 'font-large',
};

export const themeMapper = name => {
  return readingTheme[name];
};
